import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.getUserLogged();

    if (currentUser.type !== 'A' && route.data.roles !== undefined && route.data.roles === 'A') {
      this.router.navigate(['/']);
      return false;
    }

    return this.verifyAccess();
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.verifyAccess();
  }

  verifyAccess() {
    if (this.authService.isTokenExpired() || _.isEmpty(this.authService.getUserLogged())) {
      this.authService.logout();
      return false;
    } else {
      return true;
    }
  }

}
